import React from 'react';
import { injectIntl } from 'react-intl';
import { generateUUID, autotranslateText } from '../../lib/ep.js';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import ('react-tooltip/dist/react-tooltip.css');

const Tooltip = (props) => {
	const tooltip = props?.children ?? false;
	if(tooltip === false || tooltip == "") return null;

	const link = props?.link ?? false;
	const _target = props?._target ?? '_blank';
	const size = props?.size ?? 'normal';
	const position = props?.position ?? 'right';

	let icon = (props.icon != undefined) ? `custom_icon ${props.icon}` : 'knk-help-ui';
	const with_icon = props?.with_icon ?? true;
	if(!with_icon) icon = false;

	const tooltip_id = generateUUID();
	const type = props?.type ?? null;

	const classname = props?.classname ?? `gui_tooltip_react is_${size}`;
	let classes = classname.split(" ");
	if(props._class) {
		for(var i in props._class) {
			switch(i) {
				default:
					classes.push(props._class[i]);
					break;
			}
		}
	}

	let parent_classes = ['gui_tooltip_container', 'not_awesome'];
	if(props.parent_classes != undefined) parent_classes.push(props.parent_classes);

	const base_props = {
		'data-tooltip-id':tooltip_id,
		'data-tooltip-position-strategy':'fixed',
		'data-tooltip-place':position,
		'data-tooltip-offset':props?.offset ?? 10,
		'data-tooltip-variant':props?.effect ?? 'dark',
	};

	const tooltip_contents = autotranslateText(tooltip, props.autotranslate, props.intl);
	// (do NOT set it to false or it will never display)
	const automatic_open = props.open;	// true || null

	return (
		<span class={parent_classes.join(" ")}>
			{(icon !== false && link) && (
				<a
					{...base_props}
					href={link}
					target={_target}
					className={`is_tooltip is_tooltip_icon ${icon}`}
				/>
			)}

			{(icon !== false && !link) && (
				<span
					{...base_props}
					className={`is_tooltip is_tooltip_icon ${icon}`}
				/>
			)}

			{(icon === false) && (
				<span
					{...base_props}
					className="is_tooltip is_fullscreen relative_to_container"
				/>
			)}

			<ReactTooltip
				className={classes.join(" ")}
				aria-haspopup='true'
				disableStyleInjection='core'
				isOpen={automatic_open}
				id={tooltip_id}
				type={type}
				render={(props) => {
					return (
						<span
							dangerouslySetInnerHTML={{
								__html:tooltip_contents,
							}}
						/>
					)
				}}
			/>
		</span>
	);
}

export default injectIntl(Tooltip);